import { render, staticRenderFns } from "./PopularList.vue?vue&type=template&id=216290c4&scoped=true&"
import script from "./PopularList.vue?vue&type=script&lang=js&"
export * from "./PopularList.vue?vue&type=script&lang=js&"
import style0 from "./PopularList.vue?vue&type=style&index=0&id=216290c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216290c4",
  null
  
)

export default component.exports